var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "gameField",
      staticClass: "game-field",
      style: { "--total-width": _vm.totalPlatformsWidth + "rem" },
    },
    [
      _vm._m(0),
      _vm.debugInfo && _vm.debugMode
        ? _c("div", { staticClass: "debug-info" }, [
            _c("div", { staticClass: "debug-info__title" }, [
              _vm._v("🐛 Debug Info (像素)"),
            ]),
            _c("div", { staticClass: "debug-info__section" }, [
              _c("div", { staticClass: "debug-info__section-title" }, [
                _vm._v("📐 元素尺寸："),
              ]),
              _c("div", { staticClass: "debug-info__item" }, [
                _c("span", [_vm._v("容器:")]),
                _vm._v(" " + _vm._s(_vm.debugInfo.containerWidth) + "px "),
              ]),
              _c("div", { staticClass: "debug-info__item" }, [
                _c("span", [_vm._v("小鸡:")]),
                _vm._v(
                  " " +
                    _vm._s(_vm.debugInfo.chickenWidth) +
                    "×" +
                    _vm._s(_vm.debugInfo.chickenHeight) +
                    "px "
                ),
              ]),
              _c("div", { staticClass: "debug-info__item" }, [
                _c("span", [_vm._v("小鸡容器:")]),
                _vm._v(
                  " " +
                    _vm._s(_vm.debugInfo.chickenContainerWidth) +
                    "×" +
                    _vm._s(_vm.debugInfo.chickenHeight) +
                    "px "
                ),
              ]),
              _c("div", { staticClass: "debug-info__item" }, [
                _c("span", [_vm._v("平台:")]),
                _vm._v(
                  " " +
                    _vm._s(_vm.debugInfo.platformWidth) +
                    "×" +
                    _vm._s(_vm.debugInfo.platformHeight) +
                    "px "
                ),
              ]),
              _c("div", { staticClass: "debug-info__item" }, [
                _c("span", [_vm._v("Padding:")]),
                _vm._v(
                  " L:" +
                    _vm._s(_vm.debugInfo.paddingLeft) +
                    "px R:" +
                    _vm._s(_vm.debugInfo.paddingRight) +
                    "px "
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "debug-info__section" },
              [
                _c("div", { staticClass: "debug-info__section-title" }, [
                  _vm._v("🦘 跳跃："),
                ]),
                _c("div", { staticClass: "debug-info__item" }, [
                  _c("span", [_vm._v("From:")]),
                  _vm._v(
                    " Platform " + _vm._s(_vm.debugInfo.fromPlatform + 1) + " "
                  ),
                ]),
                _c("div", { staticClass: "debug-info__item" }, [
                  _c("span", [_vm._v("To:")]),
                  _vm._v(
                    " Platform " + _vm._s(_vm.debugInfo.toPlatform + 1) + " "
                  ),
                ]),
                _c("div", { staticClass: "debug-info__item" }, [
                  _c("span", [_vm._v("Distance:")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.debugInfo.distance) +
                      "% = " +
                      _vm._s(_vm.debugInfo.distancePx) +
                      "px "
                  ),
                ]),
                _c("div", { staticClass: "debug-info__item" }, [
                  _c("span", [_vm._v("Compensation:")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.debugInfo.compensation) +
                      "% = " +
                      _vm._s(_vm.debugInfo.compensationPx) +
                      "px "
                  ),
                ]),
                _c("div", { staticClass: "debug-info__item" }, [
                  _c("span", [_vm._v("Adjusted Position:")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.debugInfo.adjustedPosition) +
                      "% = " +
                      _vm._s(_vm.debugInfo.adjustedPositionPx) +
                      "px "
                  ),
                ]),
                _vm.debugInfo.actualJumpOffsetPx !== undefined
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "debug-info__item debug-info__item--actual",
                        },
                        [
                          _c("span", [_vm._v("Actual Jump Offset:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.debugInfo.actualJumpOffsetPx) +
                              "px "
                          ),
                          _vm.debugInfo.actualJumpOffsetPx !== 0
                            ? _c("span", { staticClass: "debug-info__diff" }, [
                                _vm._v(
                                  " (diff: " +
                                    _vm._s(
                                      _vm.debugInfo.actualJumpOffsetPx > 0
                                        ? "+"
                                        : ""
                                    ) +
                                    _vm._s(_vm.debugInfo.actualJumpOffsetPx) +
                                    "px) "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "debug-info__item debug-info__item--actual",
                        },
                        [
                          _c("span", [_vm._v("Expected Platform Center:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.debugInfo.expectedPlatformCenterPx) +
                              "px "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "debug-info__item debug-info__item--actual",
                        },
                        [
                          _c("span", [_vm._v("Actual Chicken Position:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.debugInfo.actualChickenPositionPx) +
                              "px "
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "debug-info__section" },
              [
                _c("div", { staticClass: "debug-info__section-title" }, [
                  _vm._v("💤 空闲位置："),
                ]),
                _c("div", { staticClass: "debug-info__item" }, [
                  _c("span", [_vm._v("Offset:")]),
                  _vm._v(" " + _vm._s(_vm.debugInfo.idleOffsetPx) + "px (5%) "),
                ]),
                _c("div", { staticClass: "debug-info__item" }, [
                  _c("span", [_vm._v("Idle Position:")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.debugInfo.adjustedPosition + 5) +
                      "% = " +
                      _vm._s(_vm.debugInfo.idlePositionPx) +
                      "px "
                  ),
                ]),
                _vm.debugInfo.actualIdleOffsetPx !== undefined
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "debug-info__item debug-info__item--actual",
                        },
                        [
                          _c("span", [_vm._v("Actual Idle Offset:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.debugInfo.actualIdleOffsetPx) +
                              "px "
                          ),
                          _vm.debugInfo.actualIdleOffsetPx !==
                          _vm.debugInfo.idleOffsetPx
                            ? _c("span", { staticClass: "debug-info__diff" }, [
                                _vm._v(
                                  " (diff: " +
                                    _vm._s(
                                      _vm.debugInfo.actualIdleOffsetPx -
                                        _vm.debugInfo.idleOffsetPx >
                                        0
                                        ? "+"
                                        : ""
                                    ) +
                                    _vm._s(
                                      _vm.debugInfo.actualIdleOffsetPx -
                                        _vm.debugInfo.idleOffsetPx
                                    ) +
                                    "px) "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "debug-info__item debug-info__item--actual",
                        },
                        [
                          _c("span", [_vm._v("Actual Idle Position:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.debugInfo.actualIdlePositionPx) +
                              "px "
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
      !_vm.settingsState.disableAnimations
        ? [
            _vm.trainRenderEnabled
              ? _c(
                  "div",
                  {
                    staticClass: "game-field__background",
                    style: { left: _vm.trainPosition + "rem" },
                  },
                  [
                    !_vm.isTrainSpineBroken
                      ? _c("spine", {
                          staticClass: "train-spine",
                          attrs: {
                            modelName: "train",
                            animationName: _vm.trainAnimation,
                            assetsPath: "/static/chicken-road/train/",
                            loop: true,
                            isJson: true,
                            speed: 1,
                            fps: 60,
                            zoom: 1,
                            offset: 0,
                            loading: "lazy",
                            fetchpriority: "low",
                          },
                          on: { error: _vm.onTrainSpineError },
                        })
                      : _c("spine", {
                          staticClass: "train-spine train-spine--retry",
                          attrs: {
                            modelName: "train",
                            animationName: _vm.trainAnimation,
                            assetsPath: "/static/chicken-road/train/",
                            loop: true,
                            isJson: true,
                            speed: 1,
                            fps: 30,
                            zoom: 1,
                            offset: 0,
                            loading: "lazy",
                            fetchpriority: "low",
                          },
                          on: {
                            animationComplete: _vm.onTrainSpineRetrySuccess,
                            error: _vm.onTrainSpineRetryFailed,
                          },
                        }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.isChickenInitialized && _vm.chickenRenderEnabled
              ? _c(
                  "div",
                  {
                    staticClass: "game-field__chicken",
                    style: { left: _vm.chickenPositionX + "rem" },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "chickenContainer",
                        staticClass: "chicken-container",
                      },
                      [
                        !_vm.isChickenSpineBroken
                          ? _c("spine", {
                              staticClass: "chicken-spine",
                              attrs: {
                                "data-spine-key": _vm.chickenSpineKey,
                                modelName: "chickenroad",
                                animationName: _vm.currentAnimation,
                                assetsPath: "/static/chicken-road/chicken/",
                                loop:
                                  _vm.currentAnimation ===
                                  _vm.ChickenAnimations.IDLE,
                                isJson: true,
                                speed: 1,
                                fps: 60,
                                zoom: 0.65,
                                fetchpriority: "high",
                                loading: "eager",
                              },
                              on: {
                                animationStart: _vm.onChickenAnimationStart,
                                animationLoopComplete:
                                  _vm.onChickenAnimationLoopComplete,
                                animationComplete:
                                  _vm.onChickenAnimationComplete,
                                error: _vm.onChickenSpineError,
                              },
                            })
                          : _c("spine", {
                              staticClass: "chicken-spine chicken-spine--retry",
                              attrs: {
                                "data-spine-key":
                                  _vm.chickenSpineKey + "-retry",
                                modelName: "chickenroad",
                                animationName: _vm.currentAnimation,
                                assetsPath: "/static/chicken-road/chicken/",
                                loop:
                                  _vm.currentAnimation ===
                                  _vm.ChickenAnimations.IDLE,
                                isJson: true,
                                speed: 1,
                                fps: 30,
                                zoom: 0.65,
                                fetchpriority: "low",
                                loading: "lazy",
                              },
                              on: {
                                animationStart: _vm.onChickenAnimationStart,
                                animationLoopComplete:
                                  _vm.onChickenAnimationLoopComplete,
                                animationComplete:
                                  _vm.onChickenSpineRetrySuccess,
                                error: _vm.onChickenSpineRetryFailed,
                              },
                            }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                ref: "platformsContainer",
                staticClass: "game-field__platforms-horizontal",
              },
              [
                _c("div", {
                  staticClass: "platform-spacer",
                  style: { width: _vm.virtualScrollSpacerWidth + "rem" },
                }),
                _vm.platformsLoadingEnabled
                  ? _vm._l(_vm.mockPlatforms, function (platform) {
                      return _c(
                        "div",
                        {
                          key: platform.id + "-" + _vm.platformRenderVersion,
                          staticClass: "platform-box",
                          attrs: { "data-platform-index": platform.index },
                        },
                        [
                          !_vm.brokenSpines.has(platform.index) &&
                          _vm.isPlatformSpineActive(platform.index)
                            ? _c("spine-optimized", {
                                staticClass: "platform__spine",
                                attrs: {
                                  "data-spine-key": _vm.getPlatformAnimationKey(
                                    platform.index
                                  ),
                                  modelName: "platforms",
                                  animationName: _vm.getPlatformAnimation(
                                    platform.index
                                  ),
                                  assetsPath: "/static/chicken-road/platforms/",
                                  loop: _vm.isPlatformLooped(platform.index),
                                  isJson: true,
                                  speed: 1,
                                  fps: _vm.getPlatformFPS(platform.index),
                                  zoom: 1,
                                  offset: 0,
                                  loading: "lazy",
                                  fetchpriority: "low",
                                },
                                on: {
                                  error: function ($event) {
                                    return _vm.onPlatformSpineError(
                                      platform.index
                                    )
                                  },
                                },
                              })
                            : !_vm.brokenSpines.has(platform.index)
                            ? _c("img", {
                                staticClass: "platform__static-image",
                                attrs: {
                                  src: _vm.getStaticPlatformImage(
                                    platform.index
                                  ),
                                  alt: "Platform",
                                },
                              })
                            : _c("spine-optimized", {
                                staticClass:
                                  "platform__spine platform__spine--retry",
                                attrs: {
                                  "data-spine-retry": platform.index,
                                  modelName: "platforms",
                                  animationName: _vm.getPlatformAnimation(
                                    platform.index
                                  ),
                                  assetsPath: "/static/chicken-road/platforms/",
                                  loop: _vm.isPlatformLooped(platform.index),
                                  isJson: true,
                                  speed: 1,
                                  fps: 30,
                                  zoom: 1,
                                  offset: 0,
                                  loading: "lazy",
                                  fetchpriority: "low",
                                },
                                on: {
                                  animationComplete: function ($event) {
                                    return _vm.onSpineRetrySuccess(
                                      platform.index
                                    )
                                  },
                                  error: function ($event) {
                                    return _vm.onSpineRetryFailed(
                                      platform.index
                                    )
                                  },
                                },
                              }),
                          platform.item &&
                          _vm.shouldShowItems &&
                          _vm.shouldShowItemOnPlatform(platform.index)
                            ? _c("div", { staticClass: "platform-item" }, [
                                _c("img", {
                                  staticClass: "platform-item__image",
                                  attrs: {
                                    src: platform.item.itemPic,
                                    alt: platform.item.name || "",
                                    loading: "lazy",
                                    fetchpriority: "low",
                                  },
                                }),
                              ])
                            : platform.placeholderItemIndex
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "platform-item platform-item--placeholder",
                                },
                                [
                                  _c("img", {
                                    staticClass: "platform-item__image",
                                    attrs: {
                                      src:
                                        "/static/chicken-road/base-items/" +
                                        platform.placeholderItemIndex +
                                        ".webp",
                                      alt: "Item placeholder",
                                      loading: "lazy",
                                      fetchpriority: "low",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "platform-multiplier" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  !_vm.settingsState.streamerMode
                                    ? "x" + platform.multiplier
                                    : platform.multiplier
                                ) +
                                " "
                            ),
                          ]),
                          platform.price
                            ? _c("div", { staticClass: "platform-price" }, [
                                _c("i", { staticClass: "icon icon_coin-c" }),
                                _vm._v(" " + _vm._s(platform.price) + " "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    })
                  : _vm._l(_vm.mockPlatforms, function (platform) {
                      return _c(
                        "div",
                        {
                          key: platform.id + "-" + _vm.platformRenderVersion,
                          staticClass: "platform-box platform-box--loading",
                          attrs: { "data-platform-index": platform.index },
                        },
                        [
                          _c("div", { staticClass: "platform-placeholder" }, [
                            _c("img", {
                              staticClass: "platform-placeholder__image",
                              attrs: {
                                src: "/static/chicken-road/current-game/platform_base.webp",
                                alt: "Loading platform",
                              },
                            }),
                          ]),
                        ]
                      )
                    }),
              ],
              2
            ),
          ]
        : [
            _c("div", { staticClass: "game-field__static" }, [
              _vm.isChickenInitialized &&
              _vm.currentGameStatus !== _vm.GameStatus.LOST
                ? _c(
                    "div",
                    {
                      staticClass:
                        "game-field__chicken game-field__chicken--static",
                      class: {
                        "game-field__chicken--win":
                          _vm.currentGameStatus === _vm.GameStatus.WON,
                      },
                      style: { left: _vm.chickenPositionX + "rem" },
                    },
                    [
                      _c("div", { staticClass: "chicken-container-static" }, [
                        _c("img", {
                          staticClass: "static-chicken-image",
                          attrs: {
                            src: _vm.staticChickenImage,
                            loading: "lazy",
                            alt: "Chicken",
                          },
                        }),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "game-field__platforms-horizontal game-field__platforms-static",
                },
                [
                  _c("div", {
                    staticClass: "platform-spacer",
                    style: { width: _vm.virtualScrollSpacerWidth + "rem" },
                  }),
                  _vm._l(_vm.mockPlatforms, function (platform) {
                    return _c(
                      "div",
                      {
                        key: platform.id + "-" + _vm.platformRenderVersion,
                        staticClass: "platform-box platform-box--static",
                        attrs: { "data-platform-index": platform.index },
                      },
                      [
                        _c("img", {
                          staticClass: "platform__static-image",
                          attrs: {
                            src: _vm.getStaticPlatformImage(platform.index),
                            alt: "Platform",
                            loading: "lazy",
                          },
                        }),
                        platform.item &&
                        _vm.shouldShowItems &&
                        _vm.shouldShowItemOnPlatform(platform.index)
                          ? _c("div", { staticClass: "platform-item" }, [
                              _c("img", {
                                staticClass: "platform-item__image",
                                attrs: {
                                  src: platform.item.itemPic,
                                  alt: platform.item.name || "",
                                  loading: "lazy",
                                  fetchpriority: "low",
                                },
                              }),
                            ])
                          : platform.placeholderItemIndex
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "platform-item platform-item--placeholder",
                              },
                              [
                                _c("img", {
                                  staticClass: "platform-item__image",
                                  attrs: {
                                    src:
                                      "/static/chicken-road/base-items/" +
                                      platform.placeholderItemIndex +
                                      ".webp",
                                    alt: "Item placeholder",
                                    loading: "lazy",
                                    fetchpriority: "low",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "platform-multiplier" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                !_vm.settingsState.streamerMode
                                  ? "x" + platform.multiplier
                                  : platform.multiplier
                              ) +
                              " "
                          ),
                        ]),
                        platform.price
                          ? _c("div", { staticClass: "platform-price" }, [
                              _c("i", { staticClass: "icon icon_coin-c" }),
                              _vm._v(" " + _vm._s(platform.price) + " "),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-container" }, [
      _c("img", {
        staticClass: "logo-image",
        attrs: {
          src: require("./assets/logo.png"),
          alt: "Chicken Road",
          loading: "lazy",
          fetchpriority: "low",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }